import {
  Box,
  Button,
  Container,
  Link,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logoHeader from "assets/images/color-logo.svg";

import star from "assets/images/Vector.svg";
import { useDispatch, useSelector } from "react-redux";

import Footer from "layouts/home/components/footer";

import facebook from "../../../assets/images/Facebook.png";
import yelp from "../../../assets/images/yelp.png";
import google from "../../../assets/images/google.png";
import {
  genericReviewRequestByLink as reviewRequestByLink,
  genericRequestScan as markReviewDonRequest,
} from "features/actions/auth";

const RedirectGeneric = () => {
  const dispatch = useDispatch();
  const reviewRequestLink = useSelector((state) => state.auth.reviewRequestGenric);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const link = queryParams.get("link");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRequestByLink = async () => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("link", link);
        await dispatch(reviewRequestByLink(formData));
      } catch (error) {
        console.error("Error fetching Request By Link:", error);
      } finally {
        setLoading(false);
      }
    };

    if (link) fetchRequestByLink();
  }, [link, dispatch]);

  const handleReviewClick = (platform) => {
    const formData = new FormData();
    formData.append("link", link);
    dispatch(markReviewDonRequest(formData));
  };

  const renderReviewButton = (platform, icon, label, onClick) => (
    <NavLink to={platform} style={{ textDecoration: "none" }}>
      <Button
        onClick={onClick}
        sx={{
          border: "1px dashed #318BEC",
          borderRadius: 2,
          minHeight: 40,
          px: 3,
          display: "flex",
          gap: 1,
          alignItems: "center",
          backgroundColor: "#fff",
          textTransform: "none",
          "&:hover": { backgroundColor: "#f0f0f0" },
        }}
      >
        <img src={icon} alt={label} style={{ width: 26, height: 26 }} />
        {label}
      </Button>
    </NavLink>
  );

  return (
    <>
      {/* Header */}
      <Box
        sx={{
          backgroundColor: "#f5faff",
          position: "sticky",
          top: 0,
          zIndex: 1100,
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 1,
              px: isMobile ? 2 : 0,
            }}
          >
            <NavLink to="/">
              <img src={logoHeader} alt="logo" style={{ height: 40 }} />
            </NavLink>
            <MDButton
              onClick={() => navigate("/sign-in")}
              sx={{
                background: "#318BEC",
                color: "#fff",
                border: "2px solid #318BEC",
                px: 5,
                borderRadius: "188px",
                fontSize: 16,
                fontWeight: 700,
                fontFamily: "urbanist",
                textTransform: "none",
                "&:hover": { background: "#318BEC" },
              }}
            >
              Login
            </MDButton>
          </Box>
        </Container>
      </Box>

      {/* Main Section */}
      <Container
        maxWidth="md"
        sx={{
          height: isMobile ? "auto" : "71vh",
          py: isMobile ? 5 : 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            background: "#D0E5FA",
            width: "100%",
            maxWidth: 800,
            minHeight: 365,
            p: isMobile ? 3 : 5,
            textAlign: "center",
            borderRadius: 2,
            paddingTop: 5
          }}
        >
          {/* Star Icon */}
          <Box
            sx={{
              position: "absolute",
              top: isMobile ? 18 : -26,
              left: isMobile ? 16 : "auto",
              right: isMobile ? "auto" : 16,
              width: isMobile ? 56 : 76,
            }}
          >
            <img src={star} alt="star" style={{ width: "80%", paddingTop: 5 }} />
          </Box>

          {/* Text Content */}
          <MDTypography
            sx={{
              color: "#212121",
              fontSize: isMobile ? 28 : 48,
              fontWeight: "700",
              fontFamily: "Urbanist",
              mb: 2,
            }}
          >
            <span style={{ color: "#318BEC" }}>Leave a Review</span>
          </MDTypography>



          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                fontFamily: "Urbanist",
                fontSize: { xs: "22px", sm: "28px" },
                color: "#212121",
              }}
            >
              {reviewRequestLink?.business?.restaurant_name}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mt: 1,
                fontSize: { xs: "14px", sm: "16px" },
                color: "#555",
                fontFamily: "Urbanist",
              }}
            >
              {reviewRequestLink?.business?.business_address}
            </Typography>
          </Box>


          {/* Review Buttons */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignItems: "center",
              width: "100%",
            }}
          >
            {reviewRequestLink?.business?.business_google_page &&
              renderReviewButton(
                reviewRequestLink.business.business_google_page,
                google,
                "Leave a Review on Google",
                () => handleReviewClick("google")
              )}
            {reviewRequestLink?.business?.business_fb_page &&
              renderReviewButton(
                reviewRequestLink.business.business_fb_page,
                facebook,
                "Leave a Review on Facebook",
                () => handleReviewClick("facebook")
              )}
            {reviewRequestLink?.business?.business_yelp_page &&
              renderReviewButton(
                reviewRequestLink.business.business_yelp_page,
                yelp,
                "Leave a Review on Yelp",
                () => handleReviewClick("yelp")
              )}
          </Box>
        </Box>
      </Container>

      <Footer />
    </>
  );
};

export default RedirectGeneric;
